import React from 'react';
import clsx from 'clsx';

export interface IconTileProps extends React.HTMLAttributes<HTMLDivElement> {
    /** 40 (circle) · 48 · 52 · 56 · 64 */
    size?: 40 | 44 | 48 | 52 | 56 | 60 | 64;
    tone?: 'sunken' | 'brandSoft' | 'accentSoft' | 'card' | 'brand' | 'success';
    src?: string | null;
    alt?: string;
}

const tones = {
    sunken: 'bg-surface-sunken text-primary-300',
    brandSoft: 'bg-brandsoft text-ink-brand',
    accentSoft: 'bg-accentsoft text-accent-700',
    card: 'bg-surface-card text-ink-secondary shadow-xs',
    brand: 'bg-surface-brand text-white',
    success: 'bg-status-success text-white',
};
const radius: Record<number, string> = { 40: 'rounded-full', 44: 'rounded-md', 48: 'rounded-md', 52: 'rounded-[16px]', 56: 'rounded-[18px]', 60: 'rounded-[16px]', 64: 'rounded-lg' };
const icon: Record<number, string> = { 40: '[&>svg]:w-[19px] [&>svg]:h-[19px]', 44: '[&>svg]:w-[21px] [&>svg]:h-[21px]', 48: '[&>svg]:w-[22px] [&>svg]:h-[22px]', 52: '[&>svg]:w-6 [&>svg]:h-6', 56: '[&>svg]:w-[26px] [&>svg]:h-[26px]', 60: '[&>svg]:w-[26px] [&>svg]:h-[26px]', 64: '[&>svg]:w-[30px] [&>svg]:h-[30px]' };

/** Soft-filled icon square used for products, shops, methods. Shows the image when one is given. */
export const IconTile: React.FC<IconTileProps> = ({ size = 48, tone = 'sunken', src, alt = '', className, children, ...props }) => (
    <div
        className={clsx('shrink-0 flex items-center justify-center overflow-hidden', tones[tone], radius[size], icon[size], className)}
        style={{ width: size, height: size }}
        {...props}
    >
        {src ? <img src={src} alt={alt} className="w-full h-full object-cover" /> : children}
    </div>
);
export default IconTile;
